import { render, staticRenderFns } from "./OrderDataList.vue?vue&type=template&id=4a23c4fe&scoped=true"
import script from "./OrderDataList.vue?vue&type=script&lang=js"
export * from "./OrderDataList.vue?vue&type=script&lang=js"
import style0 from "./OrderDataList.vue?vue&type=style&index=0&id=4a23c4fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a23c4fe",
  null
  
)

export default component.exports